import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type TvChannel from "./TvChannel";

@Model()
class TvSuper extends ApplicationRecord {
  static jsonapiType = "tv_supers";

  @Attr() endTime: number;

  @Attr() excludedFrom: string;

  @Attr() programExclusion: boolean;

  @BelongsTo() source: TvChannel;

  @Attr() sourceId: number;

  @Attr() startTime: number;

  @Attr() text: string;
}

export default TvSuper;
